import type { DOMProps } from "@simplybusiness/mobius";
import { LinkButton, Text } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import classNames from "classnames/dedupe";
import type { RefAttributes } from "react";
import type { WithMetadata } from "../../pages";

export type NextCoverageElementType = HTMLDivElement;

export interface NextCoverageProps
  extends DOMProps, RefAttributes<NextCoverageElementType> {
  className?: string;
  continuationUrl: string;
  coverageName: string;
}

export const NextCoverage = ({
  ref,
  ...props
}: WithMetadata<NextCoverageProps>) => {
  const { snowplow } = useSnowplowContext();
  const {
    className,
    continuationUrl,
    coverageName,
    componentName,
    ...otherProps
  } = props;

  const classes = classNames("mobius", "mobius-next-coverage", className);
  const { variant } = otherProps;

  return (
    <div
      ref={ref}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
      data-testid="next-coverage"
    >
      <Text elementType="h2">
        You can still finish your {coverageName} quote online
      </Text>
      <Text variant="body" className="mobius-next-coverage__text">
        You&apos;re almost there - just answer a few more questions to receive
        your quote.
      </Text>
      <LinkButton
        href={continuationUrl}
        variant="secondary"
        size="sm"
        onClick={() =>
          snowplow?.trigger("nextCoverageClicked", { url: continuationUrl })
        }
      >
        Finish quote
      </LinkButton>
    </div>
  );
};

NextCoverage.displayName = "NextCoverage";
